import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/alert.service';
import { ToastService } from 'src/app/core/toast.service';
import { CategoriaApiService } from 'src/app/dao/api_categoria.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { GlobalService } from 'src/app/dao/global.service';
import { Produto } from 'src/app/model/produto';

@Component({
  selector: 'app-produto-list2',
  templateUrl: './produto-list2.page.html',
  styleUrls: ['./produto-list2.page.scss'],
})
export class ProdutoList2Page implements OnInit {
// tslint:disable-next-line: no-inferrable-types
showSearch: boolean = false;
produtos: Produto[] = [];
prod: Produto;
inicio = '';
fim = '';
user: string;
pass: string;
idCategoria;
nomeCategoria;


constructor(private route: ActivatedRoute,
            private toast: ToastService,
            private alert: AlertService,
            private apiproduto: ProdutoapiService,
            private apiCat: CategoriaApiService,
            private global: GlobalService) { }



ngOnInit() {
 this.user = this.global.user;
 this.pass = this.global.pass;

 const idParam = this.route.snapshot.paramMap.get('id');
 if (idParam) {
   // tslint:disable-next-line: radix
   this.idCategoria = parseInt(idParam);
   // tslint:disable-next-line: radix
   this.loadProd(parseInt(idParam));
 }

}

ionViewWillEnter() {
  this.user = this.global.user;
  this.pass = this.global.pass;

  const idParam = this.route.snapshot.paramMap.get('id');
  if (idParam) {
    // tslint:disable-next-line: radix
    this.idCategoria = parseInt(idParam);
    // tslint:disable-next-line: radix
    this.loadProd(parseInt(idParam));
    this.loadCat(parseInt(idParam));
  }
}


async loadCat(idCat) {
  this.apiCat.getById(idCat).then(res => {
    console.log(res);
    this.nomeCategoria = res.nome;
    //this.toast.showSucess('Produtos obtidos com sucesso!');
  }).catch(async err => {
    console.log('err', err);
    this.toast.showError('Erro ao obter Categoria');
  });
}

async loadProd(idCat) {
  this.apiproduto.GetByCat(idCat).then(res => {
    this.produtos = res;
    //this.toast.showSucess('Produtos obtidos com sucesso!');
  }).catch(async err => {
    console.log('err', err);
    this.toast.showError('Erro ao obter Produtos');
  });
}
searchButtonClick() {
  this.showSearch = true;
}

doSearchBarCancel() {
  this.showSearch = false;
  this.loadProd(this.idCategoria);
}

async doSearchBarChange($event: any) {
  let value = $event.target.value;
  // if (value && value.lenght >= 2) {
    value = value.replace(/\s+/g, "_");
  this.produtos = await this.apiproduto.GetByNomeCat(value, this.idCategoria);
  // }
}

}
